<template>
  <ul class="tickets-list">
    <TicketCard
      v-for="ticket in tickets"
      :key="ticket.id"
      class="ticket"
      :color="color"
      :ticket="ticket"
      :outline-text="formattedCurrentEdition"
    />
  </ul>
</template>

<script setup lang="ts">
import {
  PublicTicket,
  PublicTicketTypeColorEnum
} from '@/service/__generated-api'

const props = defineProps<{
  currentEdition: string | number
  color?: PublicTicketTypeColorEnum
  tickets: PublicTicket[]
}>()

const formattedCurrentEdition = computed(
  () => `'${String(props.currentEdition).slice(-2)}`
)
</script>

<style scoped lang="scss">
.tickets-list {
  --columns: 1;
  display: grid;
  grid-template-columns: repeat(var(--columns), 1fr);
  gap: rem(16px);

  @include media-up(md) {
    --columns: 2;
  }

  @include media-up(lg) {
    --columns: 3;
  }

  @include media-up(xl) {
    --columns: 4;
    gap: rem(20px);
  }
}

.ticket {
  transition: transform $transition 100ms;
}

.ticket:hover ~ .ticket,
.ticket:focus-within ~ .ticket,
.ticket:has(~ .ticket:hover),
.ticket:has(~ .ticket:focus-within) {
  transform: scale(0.9);
}
</style>
